/* eslint-disable */
import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import dayjs from 'dayjs';
import queryString from 'query-string';

import { Box, Button, CircularProgress, FormControl, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';

import { useEnumApi } from 'contexts/EnumApiContext';
import { BootstrapInput, orderNumber, ROLE } from 'data/data';
// import { getWorkingPartsByQuery } from 'components/axios/workingPartAxios';
// import { getStationsByQuery } from 'components/axios/stationAxios';
import { getEquipmentCategoriesByQuery } from 'components/axios/equipmentCategoryAxios';
import { getEquipmentsByQuery, getEquipmentsCountGroupByStatusAndSearch } from 'components/axios/equipmentAxios';
import PageInfo from 'components/PageInfo';
import CustomEnumSelect from 'components/select/CustomEnumSelect';
import CustomSelect from 'components/select/CustomSelect';
import AlertRequestLayer from 'components/layer/AlertRequestLayer';
import MaintenanceByNoAlertRequestLayer from 'components/layer/MaintenanceByNoAlertRequestLayer';
import CommonExcelDownload from "components/CommonExcelDownload";

const EquipmentMonitoring = () => {
    const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode, equipmentCategoryLevel1s, role } = useEnumApi();
    const { t } = useTranslation();

    const navigate = useNavigate();
    const [searchField, setSearchField] = useState('name');
    const [searchKeyword, setSearchKeyword] = useState('');
    const [pageInfo, setPageInfo] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
    const [equipments, setEquipments] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isParam, setIsParam] = useState(false);
    const [toggleStr, setToggleStr] = useState(true);
  
    const [equipmentOpStatus, setEquipmentOpStatus] = useState('');
    const [equipmentFaultStatus, setEquipmentFaultStatus] = useState('');
    // const [subwayCode, setSubwayCode] = useState('');
    // const [workingPartId, setWorkingPartId] = useState('');
    // const [stationId, setStationId] = useState('');
    const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
    const [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState('');
    const [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState('');
  
    // const [workingParts, setWorkingParts] = useState([]);
    // const [stations, setStations] = useState([]);
    const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
    const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState([]);
  
    const [sortModel, setSortModel] = useState(null);
    const excelTitle = t('menu.cmms.equipment');
    const excelTopHeaders = [t('message.common.subtitle.status'), t('message.common.subtitle.recent.diagnosis'), 
      //  t('message.common.subtitle.subwayline'), t('message.common.subtitle.workingPart'), t('message.common.subtitle.station.name'), 
       t('message.common.subtitle.equipment.level1'), t('message.common.subtitle.equipment.level2'), t('message.common.subtitle.equipment.level3'), 
       t('message.common.subtitle.equipment.name'), t('message.common.subtitle.equipment.number'), t('message.common.subtitle.position'), t('message.common.subtitle.defect')];
    const fileName = excelTitle+"_"+Date.now();
    const [excelDatas, setExcelDatas] = useState([]);
  
    const connectProblemDay = dayjs(new Date()).subtract(7, "d").format("YYYY-MM-DD");
  
    const [searchFields] = useState([{code:"name", title:t('message.common.subtitle.equipment.name')}, {code:"equipmentNo", title:t('message.common.subtitle.equipment.number')}]);
  
    let qs = queryString.parse(window.location.search);
    let falutStatusSelectColor = "";
    
    const [searchParam, setSearchParam] = useState({});
    const [searchParamString, setSearchParamString] = useState('');
  
    if (equipmentFaultStatus === '' || equipmentFaultStatus === "sum") {
      falutStatusSelectColor = " selected";
    }
    
    let columns = [];
    if (role === ROLE.MO.code) {
      columns = [
        { field: 'opStatus', headerName: t('message.common.subtitle.status'), sortable:true, width: 80,
          cellClassName : 'statusButton'
          , renderCell:(params)=>(
            <div style={{textAlign:"center"}} className={params.row?.opStatus === 'O' ? 'condition6' : params.row?.opStatus === 'S' ? 'condition1' : ''}>
              <Link to={'/equipment/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("EquipmentOpStatus", params.row?.opStatus)?.[0]?.title}</Link>
            </div>)
        },
        { field: 'latestCommYmd', headerName: t('message.common.subtitle.recent.diagnosis'), sortable:true, width: 150
          , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.latestCommYmd}</Link>)
        },
        // { field: 'station.workingPart.subwayLine', headerName: t('message.common.subtitle.subwayline'), sortable:true, width: 100
        //   , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("SubwayLine", params.row?.station?.workingPart?.subwayLine)?.[0]?.title}</Link>)
        // },
        // { field: 'station.workingPart.name', headerName: t('message.common.subtitle.workingPart'), sortable:true, width: 120
        //   , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.station?.workingPart?.name}</Link>)
        // },
        // { field: 'station.name', headerName: t('message.common.subtitle.station.name'), sortable:true, width: 120
        //   , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.station?.name}</Link>)
        // },
        { field: 'equipmentCtgr.parent.parent.name', headerName: t('message.common.subtitle.equipment.level1'), sortable:true,  width: 150
          , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.equipmentCtgr?.parent?.parent?.name}</Link>)
        },
        { field: 'equipmentCtgr.parent.name', headerName: t('message.common.subtitle.equipment.level2'), sortable:true,  width: 150
          , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.equipmentCtgr?.parent?.name}</Link>)
        },
        { field: 'equipmentCtgr.name', headerName: t('message.common.subtitle.equipment.level3'), sortable:true,  width: 150
          , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.equipmentCtgr?.name}</Link>)
        },
        { field: 'name', headerName: t('message.common.subtitle.equipment.name'), sortable:true, minWidth: 200
          , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.name}</Link>)
        },
        { field: 'equipmentNo', headerName: t('message.common.subtitle.equipment.number'), sortable:true, width: 150
          , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.equipmentNo}</Link>)
        },
        { field: 'location', headerName: t('message.common.subtitle.position'), sortable:true, width: 100
          , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.location}</Link>)
        },
        { field: 'status', headerName: t('message.common.subtitle.defect'), sortable:true, width: 100, cellClassName : 'statusButton'
          , renderCell:(params)=>(
            <div style={{textAlign:"center"}} className={params.row?.status}>
                <Link to={'/equipment/'+params.row?.id+searchParamString}>
                  {getEnumValueByEnumNameAndCode("EquipmentFaultStatus", params.row?.status)?.[0]?.title}
                </Link>
            </div>)
          // <div style={{textAlign:"center"}} className={params.row?.status === 'O1_F' ? 'condition1 '+params.row?.status : params.row?.status === 'O2_M' ? 'condition2'
          // : params.row?.status === 'O5_D' ? 'condition3 '+params.row?.status : params.row?.status === 'O6_C' ? 'condition4' 
          // : params.row?.status === 'O9_G' ? 'condition5 '+params.row?.status : params.row?.status === 'O7_N' ? 'condition6 '+params.row?.status : ''}>
          //   <Link to={'/equipment/'+params.row?.id+searchParamString}>
          //     {params.row?.status === 'O1_F' || params.row?.status === 'O5_D' || params.row?.status === 'O7_N' || params.row?.status === 'O9_G'? t('message.common.normal') :
          //     getEnumValueByEnumNameAndCode("EquipmentFaultStatus", params.row?.status)?.[0]?.title}
          //     </Link>
          // </div>)
        }
      ];
    } else {
      columns = [
        { field: 'opStatus', headerName: t('message.common.subtitle.status'), sortable:true, width: 80,
          cellClassName : 'statusButton'
          , renderCell:(params)=>(
            <div style={{textAlign:"center"}} className={params.row?.opStatus === 'O' ? 'condition6' : params.row?.opStatus === 'S' ? 'condition1' : ''}>
              <Link to={'/equipment/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("EquipmentOpStatus", params.row?.opStatus)?.[0]?.title}</Link>
            </div>)
        },
        { field: 'latestCommYmd', headerName: t('message.common.subtitle.recent.diagnosis'), sortable:true, width: 150
          , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.latestCommYmd}</Link>)
        },
        // { field: 'station.workingPart.subwayLine', headerName: t('message.common.subtitle.subwayline'), sortable:true, width: 100
        //   , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{getEnumValueByEnumNameAndCode("SubwayLine", params.row?.station?.workingPart?.subwayLine)?.[0]?.title}</Link>)
        // },
        // { field: 'station.workingPart.name', headerName: t('message.common.subtitle.workingPart'), sortable:true, width: 120
        //   , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.station?.workingPart?.name}</Link>)
        // },
        // { field: 'station.name', headerName: t('message.common.subtitle.station.name'), sortable:true, width: 120
        //   , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.station?.name}</Link>)
        // },
        { field: 'equipmentCtgr.parent.parent.name', headerName: t('message.common.subtitle.equipment.level1'), sortable:true,  width: 150
          , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.equipmentCtgr?.parent?.parent?.name}</Link>)
        },
        { field: 'equipmentCtgr.parent.name', headerName: t('message.common.subtitle.equipment.level2'), sortable:true,  width: 150
          , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.equipmentCtgr?.parent?.name}</Link>)
        },
        { field: 'equipmentCtgr.name', headerName: t('message.common.subtitle.equipment.level3'), sortable:true,  width: 150
          , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.equipmentCtgr?.name}</Link>)
        },
        { field: 'name', headerName: t('message.common.subtitle.equipment.name'), sortable:true, minWidth: 200
          , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.name}</Link>)
        },
        { field: 'equipmentNo', headerName: t('message.common.subtitle.equipment.number'), sortable:true, width: 150
          , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.equipmentNo}</Link>)
        },
        { field: 'location', headerName: t('message.common.subtitle.position'), sortable:true, width: 100
          , renderCell:(params)=>(<Link to={'/equipment/'+params.row?.id+searchParamString}>{params.row?.location}</Link>)
        },
        { field: 'status', headerName: t('message.common.subtitle.defect'), sortable:true, width: 100, cellClassName : 'statusButton'
          , renderCell:(params)=>(
            <div style={{textAlign:"center"}} className={params.row?.status}>
                <Link to={'/equipment/'+params.row?.id+searchParamString}>
                  {getEnumValueByEnumNameAndCode("EquipmentFaultStatus", params.row?.status)?.[0]?.title}
                </Link>
            </div>)
            // <div style={{textAlign:"center"}} className={params.row?.status === 'O1_F' ? 'condition1 '+params.row?.status : params.row?.status === 'O2_M' ? 'condition2'
            // : params.row?.status === 'O5_D' ? 'condition3 '+params.row?.status : params.row?.status === 'O6_C' ? 'condition4' 
            // : params.row?.status === 'O9_G' ? 'condition5 '+params.row?.status : params.row?.status === 'O7_N' ? 'condition6 '+params.row?.status : ''}>
            //   <Link to={'/equipment/'+params.row?.id+searchParamString}>
            //     {params.row?.status === 'O1_F' || params.row?.status === 'O5_D' || params.row?.status === 'O7_N' || params.row?.status === 'O9_G'? t('message.common.normal') :
            //     getEnumValueByEnumNameAndCode("EquipmentFaultStatus", params.row?.status)?.[0]?.title}
            //     </Link>
            // </div>)
        },
        {
          field: 'alertRequest', headerName: t('message.common.subtitle.alertRequest'), sortable:false, width: 100
          , renderCell:(params)=>(<div style={{textAlign:"center", width:"100%"}}><AlertRequestLayer id={params.row?.id} setIsLoading={setIsLoading} type="icon" /></div>)
        }
      ];
    }

    const handlePaging = (value) => {
      value = isNaN(value) ? 1 : value;
      setCurrentPage(value-1);
      setIsLoading(false);

      let searchParamCopy = {...searchParam};
      searchParamCopy.page = (value-1);
      setSearchParam(searchParamCopy);
    }

    useEffect(()=>{
      const searchOrders = searchParam.searchOrder;
      const searchParamCopy = {...searchParam};
      delete searchParamCopy.searchOrder;
      let searchString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      if (searchOrders && searchOrders.length > 0) {
        let sortString = '';
        searchOrders.forEach(order=>sortString+="&sort="+order.sort)
        searchString += sortString;
      }
      setSearchParamString("?"+searchString)
    }, [searchParam])

    useEffect(()=>{
      const searchParamCopy = {...searchParam};
      let searchOrders = [];
      if (sortModel && sortModel.length > 0) {
        searchOrders.push({sort : sortModel[0].field+","+sortModel[0].sort});
      } else {
        searchOrders.push({sort : "opStatus,asc"});
      }
      searchParamCopy.searchOrder = searchOrders;
      setSearchParam(searchParamCopy)
    },[sortModel])
  
    useEffect(()=> {
      if (qs) {
        if (qs.page && qs.page !== (currentPage)) {setCurrentPage(qs.page);}
        if (qs.size) setPageSize(qs.size);
        if (qs.searchField) setSearchField(qs.searchField);
        if (qs.searchKeyword) setSearchKeyword(qs.searchKeyword);
  
        if (qs.searchOpStatus) setEquipmentOpStatus(qs.searchOpStatus);
        if (qs.searchStatus) setEquipmentFaultStatus(qs.searchStatus);
        // if (qs.searchSubway) setSubwayCode(qs.searchSubway);
        // if (qs.searchWorkingPart) setWorkingPartId(qs.searchWorkingPart);
        // if (qs.searchStation) setStationId(qs.searchStation);
        if (qs.searchlevel1) setEquipmentCategoryLevel1Id(qs.searchlevel1);
        if (qs.searchlevel2) setEquipmentCategoryLevel2Id(qs.searchlevel2);
        if (qs.searchlevel3) setEquipmentCategoryLevel3Id(qs.searchlevel3);

        let searchParamCopy = {...searchParam};
        if (qs.page && qs.page !== (currentPage)) {searchParamCopy.page = qs.page};
        if (qs.size) {searchParamCopy.size = qs.size} ;
        if (qs.searchField) {searchParamCopy.searchField = qs.searchField};
        if (qs.searchKeyword) {searchParamCopy.searchKeyword = qs.searchKeyword};
        if (qs.searchOpStatus) {searchParamCopy.searchOpStatus = qs.searchOpStatus};
        if (qs.searchStatus) {searchParamCopy.searchStatus = qs.searchStatus};
        if (qs.searchSubway) {searchParamCopy.searchSubway = qs.searchSubway};
        if (qs.searchWorkingPart) {searchParamCopy.searchWorkingPart = qs.searchWorkingPart};
        if (qs.searchStation) {searchParamCopy.searchStation = qs.searchStation};
        if (qs.searchlevel1) {searchParamCopy.searchlevel1 = qs.searchlevel1};
        if (qs.searchlevel2) {searchParamCopy.searchlevel2 = qs.searchlevel2};
        if (qs.searchlevel3) {searchParamCopy.searchlevel3 = qs.searchlevel3};
        if (qs.sort && qs.sort.length > 0) {
          let orders = [];
          let sortModel = [];
          if (!Array.isArray(qs.sort)) {
            orders.push({sort:qs.sort});
            sortModel.push({"field": qs.sort.split(',')[0],"sort": qs.sort.split(',')[1]})
          } else {
            (qs.sort).forEach(order=>orders.push({sort:order}));
            qs.map(order=>sortModel.push({"field": order.sort.split(',')[0],"sort": order.sort.split(',')[1]}))
          }
          setSortModel(sortModel)
          searchParamCopy.searchOrder = orders;
        } else {
          delete searchParamCopy.searchOrder
        };
        setSearchParam(searchParamCopy);
      }
      setIsParam(true);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [qs.page, qs.size, qs.searchField, qs.searchKeyword, qs.searchOpStatus, qs.searchStatus
      // , qs.searchSubway, qs.searchWorkingPart, qs.searchStation
      , qs.searchlevel1, qs.searchlevel2, qs.searchlevel3]);
    
    // 호선 선택시 해당 파트 목록 가져오기
    // useEffect(()=>{
    //   if (subwayCode) {
    //     const param = {"subwayLine" : subwayCode, size:50}
    //     getWorkingPartsByQuery(param).then((data)=>{
    //       if (data && data._embedded) {
    //         let workingParts = data._embedded.workingParts;
    //         setWorkingParts(workingParts);
    //       } else {
    //         setWorkingParts([]);
    //       }
    //       setStations([]);
    //     });
    //   }
    // },[subwayCode]);
  
    // // 파트 선택시 해당 역사 목록 가져오기
    // useEffect(()=>{
    //   if (workingPartId) {
    //     const param = {"workingPart.id" : workingPartId, sort:"code,asc", size:50};
    //     getStationsByQuery(param).then((data)=>{
    //       if (data && data._embedded) {
    //         setStations(data._embedded.stations);
    //       } else {
    //         setStations([]);
    //       }
    //     });
    //   }
    // },[workingPartId]);
    
    // 설비중분류 목록
    useEffect(()=>{
      if (equipmentCategoryLevel1Id) {
        const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
        getEquipmentCategoriesByQuery(param).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded.equipmentCategories;
            if (list) {
              setEquipmentCategoryLevel2s(list);
            } else {
              setEquipmentCategoryLevel2s([]);
            }
          } else {
            setEquipmentCategoryLevel2s([]);
          }
          setEquipmentCategoryLevel3s([]);
        });
      }
    },[equipmentCategoryLevel1Id]);
  
    // 설비분류 목록
    useEffect(()=>{
      if (equipmentCategoryLevel2Id) {
        const param = { "parent.id": equipmentCategoryLevel2Id, depth: 3, size : 100, sort : "name,asc" };
        getEquipmentCategoriesByQuery(param).then((data) => {
          if (data && data._embedded) {
            const list = data._embedded.equipmentCategories;
            if (list) {
              setEquipmentCategoryLevel3s(list);
            } else {
              setEquipmentCategoryLevel3s([]);
            }
          } else {
            setEquipmentCategoryLevel3s([]);
          }
        });
      }
    },[equipmentCategoryLevel2Id]);
  
    // 목록
    useEffect(()=> {
      if ((!isLoading || sortModel != null) && !isNaN(currentPage) && isParam && getEnumValueByEnumName("EquipmentFaultStatus")) {
        equipmentList();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, isLoading, pageSize, equipmentFaultStatus, getEnumValueByEnumName("EquipmentFaultStatus"), isParam, sortModel]);
      
    let [equipmentGroupCounts, setEquipmentGroupCounts] = useState([]);
    let [totalEquipmentGroupCount, setTotalEquipmentGroupCount] = useState(0);
  
    const equipmentList = (curPage=currentPage) => {
      isNaN(curPage) && setCurrentPage(0);
      isNaN(pageSize) && setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
  
      let param = {
        page : curPage,
        size : pageSize,
        iotInstlYn : true
      };
      let countParam = {...param};
      if (equipmentOpStatus) {
        param.opStatus = equipmentOpStatus;
      }
      // if (subwayCode) {
      //   param["station.workingPart.subwayLine"] = subwayCode;
      // }
      // if (workingPartId) {
      //   param['station.workingPart.id'] = workingPartId;
      // }
      // if (stationId) {
      //   param['station.id'] = stationId;
      // }
      if (equipmentCategoryLevel1Id) {
        param['equipmentCtgr.parent.parent.id'] = equipmentCategoryLevel1Id;
      }
      if (equipmentCategoryLevel2Id) {
        param['equipmentCtgr.parent.id'] = equipmentCategoryLevel2Id;
      }
      if (equipmentCategoryLevel3Id) {
        param['equipmentCtgr.id'] = equipmentCategoryLevel3Id;
      }
      if (equipmentFaultStatus === 'problem') {
        param.latestCommYmd = 'lte('+connectProblemDay+')';
      } else {
        if (equipmentFaultStatus !== 'sum')
          param.status = equipmentFaultStatus;
        let keyword = searchKeyword;
        if (searchKeyword) {
            if (searchField && (searchField === 'name' || searchField === 'equipmentNo')) {
              keyword = 'contains('+searchKeyword+')';
            }
  
            if (searchField === 'name') {
              param.name = keyword;
            } else if (searchField === 'equipmentNo') {
              param.equipmentNo = keyword;
            }
        }
      }
      if (sortModel && sortModel.length > 0)
        param.sort = sortModel[0].field+","+sortModel[0].sort;
      else
        param.sort = "opStatus,asc";

      Promise.all([
        getEquipmentsByQuery(param).then((data)=>{
          if (data != null) {
            if(data.page) {
              setPageInfo(data.page);
            } else {
              setCurrentPage(0);
              pageInfo = {
                size : pageInfo.size,
                totalElements : 0,
                totalPages : 0,
                number : 0
              }
              setPageInfo(pageInfo);
            }
            if(data._embedded) {
              let list = data._embedded.equipments;
              setEquipments(list);
              setIsLoading(true);
              return data.page.totalElements;
            } else {
              setEquipments([]);
            }
          } else {
            pageInfo = {
              size : pageInfo.size,
              totalElements : 0,
              totalPages : 0,
              number : 0
            }
            setPageInfo(pageInfo);
            setEquipments([]);
          }
          setIsLoading(true);
          return 0;
        }),
        getEquipmentsCountGroupByStatusAndSearch(countParam).then((res)=>{
          equipmentGroupCounts = [];
          totalEquipmentGroupCount = 0;
          if (res != null) {
            let isInclude = false;
            let statussData = res.data;
    
            let equipmentFaultStatuss = getEnumValueByEnumName("EquipmentFaultStatus");
            if (equipmentFaultStatuss) {
                // equipmentFaultStatuss.map(status => status.code === 'O1_F' ? status.sort = 4 : '')
                // equipmentFaultStatuss.map(status => status.code === 'O2_M' ? status.sort = 5 : '')
                // equipmentFaultStatuss.map(status => status.code === 'O5_D' ? status.sort = 3 : '')
                // equipmentFaultStatuss.map(status => status.code === 'O6_C' ? status.sort = 6 : '')
                // equipmentFaultStatuss.map(status => status.code === 'O7_N' ? status.sort = 2 : '')
                // equipmentFaultStatuss.map(status => status.code === 'O9_G' ? status.sort = 1 : '')
                equipmentFaultStatuss.map(status => status.code === 'O4_C' ? status.sort = 4 : '')
                equipmentFaultStatuss.map(status => status.code === 'O3_A' ? status.sort = 3 : '')
                equipmentFaultStatuss.map(status => status.code === 'O2_I' ? status.sort = 2 : '')
                equipmentFaultStatuss.map(status => status.code === 'O1_N' ? status.sort = 1 : '')
                orderNumber(equipmentFaultStatuss, "sort")
  
                equipmentFaultStatuss.map(function(item1) {
                isInclude = false;
                statussData.map(function(item2) {
                  if (item2.id === item1.code) {
                    equipmentGroupCounts.push(...[item2]);
                    totalEquipmentGroupCount += item2.count;
                    isInclude = true;
                  }
                })
    
                if (!isInclude) {
                  let defaultStatus = [{
                    name : item1.code,
                    id : item1.code,
                    title : item1.title,
                    count : 0,
                  }];
                  equipmentGroupCounts.push(...defaultStatus);
                }
              })
            }
            setEquipmentGroupCounts(equipmentGroupCounts);
            setTotalEquipmentGroupCount(totalEquipmentGroupCount);
          }
        })
      ]).then((res)=>{
        delete param.page;
        param.page = 0;
        const totalCount = res[0];
        if (totalCount) {
          delete param.size;
          param.size = totalCount;
          getEquipmentsByQuery(param).then((data)=>{
            if (data != null) {
              if(data._embedded) {
                let list = data._embedded.equipments;
                let excelDatas = [];
                let excelData = [];
                list && list.forEach(function (column, a) {
                  excelData = [
                      ((getEnumValueByEnumNameAndCode("EquipmentOpStatus", column.opStatus)?.[0]?.title) || ''),
                      ((column.latestCommYmd) || ''),
                      // ((getEnumValueByEnumNameAndCode("SubwayLine", column.station?.workingPart?.subwayLine)?.[0]?.title) || ''),
                      // ((column.station?.workingPart?.name) || ''),
                      // ((column.station?.name) || ''),
                      ((column.equipmentCtgr?.parent?.parent?.name) || ''),
                      ((column.equipmentCtgr?.parent?.name) || ''),
                      ((column.equipmentCtgr?.name) || ''),
                      ((column.name) || ''),
                      ((column.equipmentNo) || ''),
                      ((column.location) || ''),
                      (((getEnumValueByEnumNameAndCode("EquipmentFaultStatus", column.status)?.[0]?.title) || ''))
                      // ((column.status == 'O9_G' || column.status == 'O7_N' || column.status == 'O5_D' || column.status == 'O1_F') ? t('message.common.normal') :
                      //   ((getEnumValueByEnumNameAndCode("EquipmentFaultStatus", column.status)?.[0]?.title) || '')
                      // )
                  ];
                  excelDatas.push(excelData);
                });
                setExcelDatas(excelDatas);
              } else {
                setExcelDatas([]);
              }
            } else {
              setExcelDatas([]);
            }
          })
        } else {
          setExcelDatas([]);
        }
      })
      setIsLoading(true);
    }
   
    const handleInput = (event) => {
      event.preventDefault();
      setSearchKeyword(event.target.value.trim());
    };
  
    const handleOnKeyPress = e => {
      if (e.key === 'Enter') {
        handleSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
      }
    };
 
    const handleSearch = (event) => {
      event.preventDefault();
      setCurrentPage(0);
      pageInfo.number = 0;
      setPageInfo(pageInfo);
      equipmentList(0);
      setExcelDatas([]);

      let searchParamCopy = {...searchParam};
      searchParamCopy.page = 0;
      if (pageSize) {searchParamCopy.size = pageSize};
      if (searchField) {searchParamCopy.searchField = searchField};
      if (searchKeyword) {searchParamCopy.searchKeyword = searchKeyword};
      if (equipmentOpStatus) {searchParamCopy.searchOpStatus = equipmentOpStatus};
      if (equipmentFaultStatus) {searchParamCopy.searchStatus = equipmentFaultStatus};
      // if (subwayCode) {searchParamCopy.searchSubway = subwayCode};
      // if (workingPartId) {searchParamCopy.searchWorkingPart = workingPartId};
      // if (stationId) {searchParamCopy.searchStation = stationId};
      if (equipmentCategoryLevel1Id) {searchParamCopy.searchlevel1 = equipmentCategoryLevel1Id};
      if (equipmentCategoryLevel2Id) {searchParamCopy.searchlevel2 = equipmentCategoryLevel2Id};
      if (equipmentCategoryLevel3Id) {searchParamCopy.searchlevel3 = equipmentCategoryLevel3Id};
      setSearchParam(searchParamCopy)
      const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      navigate("?"+paramString)
    };

    const handleMobileOnKeyPress = e => {
      if (e.key === 'Enter') {
        handleMobileSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
      }
    };

    const handleMobileSearch = (event) => {
      handleSearch(event);
      handleClose();
    };
  
    const statusTapSearch = (vCode) => {
      setCurrentPage(0);
      pageInfo.number = 0;
      setPageInfo(pageInfo);
      setEquipmentFaultStatus(vCode);
      initSearch();

      let searchParamCopy = {...searchParam};
      searchParamCopy.page = 0;
      if (pageSize) {searchParamCopy.size = pageSize};
      if (searchField) {searchParamCopy.searchField = searchField};
      searchParamCopy.searchStatus = vCode;
      searchParamCopy.searchKeyword = '';
      searchParamCopy.searchOpStatus = '';
      searchParamCopy.searchSubway = '';
      searchParamCopy.searchWorkingPart = '';
      searchParamCopy.searchStation = '';
      searchParamCopy.searchlevel1 = '';
      searchParamCopy.searchlevel2 = '';
      searchParamCopy.searchlevel3 = '';
      setSearchParam(searchParamCopy)
      const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
      navigate("?"+paramString)
    };
  
    const initSearch = ()  => {
      setEquipmentOpStatus('');
      // setSubwayCode('');
      // setWorkingPartId('');
      // setStationId('');
      setEquipmentCategoryLevel1Id('');
      setEquipmentCategoryLevel2Id('');
      setEquipmentCategoryLevel3Id('');
      setToggleStr(!toggleStr);
      setSearchKeyword('');
      setCurrentPage(0);
      setIsLoading(false);
      setExcelDatas([]);
    };

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };

    const handleClose = (event, reason) => {
      if (reason !== 'backdropClick') {
        setOpen(false);
      }
    };
  
    // if (isLoading) {
    return (
      <div className="sub_container">
        <ul className='condition' style={{marginTop:"px"}}>
          <li className={`sum${falutStatusSelectColor}`} onClick={() => statusTapSearch('sum')} style={{cursor:"pointer"}}>{t('message.common.total')}: {totalEquipmentGroupCount}</li>
          {equipmentGroupCounts &&
            equipmentGroupCounts.map(function(item, i) {
              falutStatusSelectColor = "";
              if (item.id === equipmentFaultStatus) {
                falutStatusSelectColor = " selected";
              }
              let addTitle = '';
              // if (item.id === 'O9_G')
              //   addTitle = 'ISO(A)';
              // else if (item.id === 'O7_N')
              //   addTitle = 'ISO(B)';
              // else if (item.id === 'O5_D')
              //   addTitle = 'ISO(C)';
              // else if (item.id === 'O1_F')
              //   addTitle = 'ISO(D)';
              return (
                <li key={i} className={`${item.id}${falutStatusSelectColor}`} onClick={() => statusTapSearch(item.id)} style={{cursor:"pointer"}}>{addTitle == '' && item.title}{addTitle}: {item.count}</li>      
              )
            }) }
        </ul>
        
        <div className='selectbox'>
          <div className="desktop_serach">
            <Box component="form">
              <div>
                <div>
                {/* {getEnumValueByEnumName("EquipmentOpStatus") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={equipmentOpStatus}
                      label={t('message.common.subtitle.opStatus')}
                      labelName={t('message.common.subtitle.opStatus')}
                      name={'equipmentOpStatus'}
                      defaultValue={equipmentOpStatus}
                      onChange={(e)=>{
                        setEquipmentOpStatus(e.target.value);
                      }}
                      list={getEnumValueByEnumName("EquipmentOpStatus")}
                  />
                  </FormControl>
                  } */}
                  {/* {getEnumValueByEnumName("SubwayLine") && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={subwayCode}
                      label={t('message.common.subtitle.subwayline')}
                      labelName={t('message.common.subtitle.subwayline')}
                      name={'subway'}
                      defaultValue={subwayCode}
                      onChange={(e)=>{
                        setSubwayCode(e.target.value);
                        setWorkingPartId('');
                        setStationId('');
                      }}
                      list={getEnumValueByEnumName("SubwayLine")}
                  />
                  </FormControl>
                  }
                  {workingParts && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={workingPartId}
                      label={t('message.common.subtitle.workingPart')}
                      labelName={t('message.common.subtitle.workingPart')}
                      name={'workPart'}
                      defaultValue={workingPartId}
                      onChange={(e)=>{
                        setWorkingPartId(e.target.value);
                        setStationId('');
                      }}
                      list={workingParts}
                  />
                  </FormControl>
                  }
                  {stations && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={stationId}
                      label={t('message.common.subtitle.station')}
                      labelName={t('message.common.subtitle.station')}
                      name={'station'}
                      defaultValue={stationId}
                      onChange={(e)=>{
                        setStationId(e.target.value);
                      }}
                      list={stations}
                  />
                  </FormControl>
                  } */}
                  {equipmentCategoryLevel1s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel1Id}
                      label={t('message.common.subtitle.equipment.level1')}
                      labelName={t('message.common.subtitle.equipment.level1')}
                      name={'level1'}
                      defaultValue={equipmentCategoryLevel1Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel1Id(e.target.value);
                        setEquipmentCategoryLevel2Id('');
                        setEquipmentCategoryLevel3Id('');
                      }}
                      list={equipmentCategoryLevel1s}
                  />
                  </FormControl>
                  }
                  {equipmentCategoryLevel2s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel2Id}
                      label={t('message.common.subtitle.equipment.level2')}
                      labelName={t('message.common.subtitle.equipment.level2')}
                      name={'level2'}
                      defaultValue={equipmentCategoryLevel2Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel2Id(e.target.value);
                        setEquipmentCategoryLevel3Id('');
                      }}
                      list={equipmentCategoryLevel2s}
                  />
                  </FormControl>
                  }
                  {equipmentCategoryLevel3s && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                      key={equipmentCategoryLevel3Id}
                      label={t('message.common.subtitle.equipment.level3')}
                      labelName={t('message.common.subtitle.equipment.level3')}
                      name={'level3'}
                      defaultValue={equipmentCategoryLevel3Id}
                      onChange={(e)=>{
                        setEquipmentCategoryLevel3Id(e.target.value);
                      }}
                      list={equipmentCategoryLevel3s}
                  />
                  </FormControl>
                  }
                  <div style={{display:"inline-block"}}>
                  {searchFields && 
                  <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                      key={searchField}
                      label={t('message.common.btn.search')}
                      labelName={t('message.common.btn.search')}
                      name={'searchField'}
                      defaultValue={searchField}
                      onChange={(e)=>{
                        setSearchField(e.target.value);
                      }}
                      list={searchFields}
                  />
                  </FormControl>
                  }
                    <FormControl sx={{ m: 1 }} variant="standard">
                      <BootstrapInput id="demo-customized-textbox" className='search_11' style={{ width : "130px" }} value={searchKeyword || ''} onChange={handleInput} onKeyPress={handleOnKeyPress}/>
                    </FormControl>
  
                    <Button className='search_icon1' variant="contained" style={{marginTop:"0",padding:"12px 15px"}} onClick={handleSearch}>
                      <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/search.png`} alt='' /></span>{t('message.common.btn.search')}
                    </Button>
                  </div>
                </div>
              </div>
            </Box>
          </div>

          <div className="mobile_serach" style={{display:"none"}}>
            <Button style={{width:"100%",marginBottom:"10px"}} variant="contained" color="secondary" onClick={handleClickOpen}>
              {t('message.common.text.search.category.open')}
            </Button>
            <Dialog className="mobile_serach_box" disableEscapeKeyDown open={open} onClose={handleClose}>
              <DialogTitle>{t('message.common.text.search.category.select')}</DialogTitle>
              <DialogContent>
                  <Box component="form">
                    <div>
                      <div>
                      {/* {getEnumValueByEnumName("EquipmentOpStatus") && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                          <CustomEnumSelect
                            key={equipmentOpStatus}
                            label={t('message.common.subtitle.opStatus')}
                            labelName={t('message.common.subtitle.opStatus')}
                            name={'equipmentOpStatus'}
                            defaultValue={equipmentOpStatus}
                            onChange={(e)=>{
                              setEquipmentOpStatus(e.target.value);
                            }}
                            list={getEnumValueByEnumName("EquipmentOpStatus")}
                        />
                        </FormControl>
                        }
                        {getEnumValueByEnumName("SubwayLine") && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                          <CustomEnumSelect
                            key={subwayCode}
                            label={t('message.common.subtitle.subwayline')}
                            labelName={t('message.common.subtitle.subwayline')}
                            name={'subway'}
                            defaultValue={subwayCode}
                            onChange={(e)=>{
                              setSubwayCode(e.target.value);
                              setWorkingPartId('');
                              setStationId('');
                            }}
                            list={getEnumValueByEnumName("SubwayLine")}
                        />
                        </FormControl>
                        }
                        {workingParts && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                          <CustomSelect
                            key={workingPartId}
                            label={t('message.common.subtitle.workingPart')}
                            labelName={t('message.common.subtitle.workingPart')}
                            name={'workPart'}
                            defaultValue={workingPartId}
                            onChange={(e)=>{
                              setWorkingPartId(e.target.value);
                              setStationId('');
                            }}
                            list={workingParts}
                        />
                        </FormControl>
                        }
                        {stations && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                          <CustomSelect
                            key={stationId}
                            label={t('message.common.subtitle.station')}
                            labelName={t('message.common.subtitle.station')}
                            name={'station'}
                            defaultValue={stationId}
                            onChange={(e)=>{
                              setStationId(e.target.value);
                            }}
                            list={stations}
                        />
                        </FormControl>
                        } */}
                        {equipmentCategoryLevel1s && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                          <CustomSelect
                            key={equipmentCategoryLevel1Id}
                            label={t('message.common.subtitle.equipment.level1')}
                            labelName={t('message.common.subtitle.equipment.level1')}
                            name={'level1'}
                            defaultValue={equipmentCategoryLevel1Id}
                            onChange={(e)=>{
                              setEquipmentCategoryLevel1Id(e.target.value);
                              setEquipmentCategoryLevel2Id('');
                              setEquipmentCategoryLevel3Id('');
                            }}
                            list={equipmentCategoryLevel1s}
                        />
                        </FormControl>
                        }
                        {equipmentCategoryLevel2s && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                          <CustomSelect
                            key={equipmentCategoryLevel2Id}
                            label={t('message.common.subtitle.equipment.level2')}
                            labelName={t('message.common.subtitle.equipment.level2')}
                            name={'level2'}
                            defaultValue={equipmentCategoryLevel2Id}
                            onChange={(e)=>{
                              setEquipmentCategoryLevel2Id(e.target.value);
                              setEquipmentCategoryLevel3Id('');
                            }}
                            list={equipmentCategoryLevel2s}
                        />
                        </FormControl>
                        }
                        {equipmentCategoryLevel3s && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                          <CustomSelect
                            key={equipmentCategoryLevel3Id}
                            label={t('message.common.subtitle.equipment.level3')}
                            labelName={t('message.common.subtitle.equipment.level3')}
                            name={'level3'}
                            defaultValue={equipmentCategoryLevel3Id}
                            onChange={(e)=>{
                              setEquipmentCategoryLevel3Id(e.target.value);
                            }}
                            list={equipmentCategoryLevel3s}
                        />
                        </FormControl>
                        }
                        <div style={{display:"inline-block"}}>
                        {searchFields && 
                        <FormControl sx={{ m: 1, minWidth: 80 }}>
                          <CustomEnumSelect
                            key={searchField}
                            label={t('message.common.btn.search')}
                            labelName={t('message.common.btn.search')}
                            name={'searchField'}
                            defaultValue={searchField}
                            onChange={(e)=>{
                              setSearchField(e.target.value);
                            }}
                            list={searchFields}
                        />
                        </FormControl>
                        }
                          <FormControl sx={{ m: 1 }} variant="standard">
                            <BootstrapInput id="demo-customized-textbox" style={{ width : "130px" }} value={searchKeyword} onChange={handleInput} onKeyPress={handleMobileOnKeyPress}/>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </Box>
                  </DialogContent>
                <DialogActions>
                  <Button onClick={handleMobileSearch} variant="contained">{t('message.common.btn.search')}</Button>
                  <Button onClick={handleClose} variant="contained" color="secondary">{t('message.common.btn.cancel')}</Button>
                </DialogActions>
              </Dialog>
          </div>
        </div>

        <Box id="tableDiv">
          <DataGridPro
            rows={equipments && equipments !== undefined ? equipments : []}
            columns={columns}
            disableColumnFilter
            sortModel={sortModel || []}
            onSortModelChange={setSortModel}
            sx={{
              "& .MuiDataGrid-footerContainer, & .MuiDataGrid-toolbarContainer": {
                display: "none",
              },
              "& .MuiDataGrid-cell.statusReport" : {overflow:"unset !important"}
            }}
          />
        </Box>

        <div className="btn_right" style={{justifyContent:"space-between"}}>
          { role !== ROLE.MO.code ?
          <div>
            <AlertRequestLayer 
            // subwayCode={subwayCode} workingPartId={workingPartId} stationId={stationId}
            equipmentCategoryLevel1Id={equipmentCategoryLevel1Id} equipmentCategoryLevel2Id={equipmentCategoryLevel2Id} equipmentCategoryLevel3Id={equipmentCategoryLevel3Id} setIsLoading={setIsLoading} />
            { role !== ROLE.MO.code &&
              <>
              <span style={{marginLeft:"10px"}}></span>
              <MaintenanceByNoAlertRequestLayer 
              // subwayCode={subwayCode} workingPartId={workingPartId} stationId={stationId}
              equipmentCategoryLevel1Id={equipmentCategoryLevel1Id} equipmentCategoryLevel2Id={equipmentCategoryLevel2Id} equipmentCategoryLevel3Id={equipmentCategoryLevel3Id} setIsLoading={setIsLoading} />
              </>
            }
          </div>
          :
          <div></div>
          }
          <div style={{display: "flex",justifyContent: "flex-end"}}>
            
            {(excelDatas && excelDatas.length > 0) ?
            <div className='no-print-page'>
                &nbsp;&nbsp;<CommonExcelDownload excelDatas={excelDatas} excelHeader={excelTopHeaders} title={`${excelTitle}`} filename={`${fileName}.xlsx`} />
            </div>
            :
            (equipments && equipments.length > 0) ?
            <div className='no-print-page' style={{color:"#FFF"}}>
              <Box sx={{ display: 'flex', color:"#FFF" }}>
                {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
              </Box>
            </div>
            : ''
            }
          </div>
        </div>
        
        <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>
          
      </div>
    );
  // }
}

export default EquipmentMonitoring;